import { create } from 'zustand';

import { log } from '@/shared/utils/log';

import { ModalData } from './types';

type ModalsStore = {
  data: ModalData[];
  isOpened: boolean;
  openModal: (data: ModalData) => void;
  closeModal: () => void;
};

export const useModalsStore = create<ModalsStore>((set, get) => ({
  data: [],
  isOpened: false,
  openModal: (data) => {
    log.trace(`openModal: ${data.type}`);
    const newData = get().data.slice(0).concat(data);
    set({ data: newData, isOpened: newData.length > 0 });
  },
  closeModal: () => {
    log.trace('closeModal');
    const newData = get().data.slice(0, get().data.length - 1);
    set({ data: newData, isOpened: newData.length > 0 });
  },
}));
